import { SclaApplication } from 'features/scla/types';

function ownerId(app: SclaApplication): string {
  const owner = app.user as { _id?: string } | string | undefined;
  if (!owner) return '';
  if (typeof owner === 'string') return owner;
  return owner._id ? String(owner._id) : '';
}

function savedAt(value: Date | string | null | undefined): number {
  if (!value) return 0;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? 0 : time;
}

/**
 * A save or reload must not replace a newer copy of the same application.
 * A response for a different account is ignored while that account is signed in.
 */
export default function chooseSclaApplication(
  current: SclaApplication | null,
  incoming: SclaApplication,
  sessionUserId?: string,
): SclaApplication | null {
  const incomingOwner = ownerId(incoming);
  if (sessionUserId && incomingOwner && incomingOwner !== sessionUserId) {
    return current;
  }
  if (!current || current._id !== incoming._id) return incoming;
  if (savedAt(current.updatedOn) > savedAt(incoming.updatedOn)) return current;
  return incoming;
}
